module.exports = __webpack_public_path__ + "static/media/Insta-image-2.feb987b2.jpeg";